import { Overlay } from "@angular/cdk/overlay";
import { CdkPortal } from "@angular/cdk/portal";
import { OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";
import { DisposeMixin } from "../../../mixins/dispose.mixin";
import { EmptyMixin } from "../../../mixins/empty.mixin";
import { LockMixin } from "../../../mixins/lock.mixin";
import { DialogModel } from "../../../models/components/dialog.model";
import { DialogService } from "../../../services/components/dialog.service";
import { ProductPopUpBaseService } from "../../../services/components/product-pop-up-base.service";
import {ObservableOnDestroyMixin} from "../../../mixins/observable-on-destroy.mixin";
import {takeUntil} from "rxjs/operators";

export class ProductPopUpBaseComponent<TPopUpModel> extends ObservableOnDestroyMixin(DisposeMixin(LockMixin(EmptyMixin))) implements OnInit, OnDestroy {
    public model: TPopUpModel;

    @ViewChild("popUpView", { read: CdkPortal })
    public popUpView: CdkPortal;

    public constructor(
        protected popUpService: ProductPopUpBaseService<TPopUpModel>,
        protected overlay: Overlay,
        protected dialogService: DialogService
    ) {
        super();
    }

    public ngOnInit(): void {
        this.popUpService.showPopUpObservable
            .pipe(takeUntil(this.destroy$))
            .subscribe(model => this.showPopUp(model));
        this.popUpService.hidePopUpObservable
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => this.hidePopUp());
    }

    protected showPopUp(model: TPopUpModel): void {
        console.log("IN pop-up-base component SHOW");
        this.model = model;
        this.dialogService.show(new DialogModel({
            positionStrategy: this.overlay.position()
                .global()
                .centerHorizontally()
                .centerVertically(),
            hasBackdrop: true,
            backdropClass: "pcg-products-details__overlay",
            width: 495,
            scrollStrategy: this.overlay.scrollStrategies.block()
        }, this.popUpView));
    }

    private hidePopUp(): void {
        this.model = null;
        this.dialogService.hide();
    }

    public ngOnDestroy(): void {
        this.dispose();
    }
}
